import {
  ADD_TO_CART,
  CALCULATE_PRODUCT_PRICE,
  CALCULATE_SUB_TOTAL,
  COUNT_TOTAL,
  DECREMENT_QUANTITY,
  REMOVE_FROM_CART,
} from "./actionTypes";

const initialState = {
  cart: [],
  subTotal: 0,
  totalCount: 0,
};

const cartReducer = (state = initialState, action) => {
  let selectedProduct;
  if (action.payload) {
    selectedProduct = state.cart.find(
      (product) => product.id === action.payload.id
    );
  }

  switch (action.type) {
    case ADD_TO_CART:
      if (selectedProduct) {
        const newCart = state.cart.filter(
          (product) => product.id !== selectedProduct.id
        );

        selectedProduct.quantity = selectedProduct.quantity + 1;

        return {
          ...state,
          cart: [...newCart, selectedProduct],
        };
      }
      return {
        ...state,
        cart: [...state.cart, { ...action.payload, quantity: 1 }],
      };

    case DECREMENT_QUANTITY:
      return {
        ...state,
        cart: state.cart.map((product) => {
          if (product.id === selectedProduct.id) {
            const updatedQuantity = product.quantity - 1;
            return { ...product, quantity: updatedQuantity };
          }
          return product;
        }),
      };

    case CALCULATE_PRODUCT_PRICE:
      return {
        ...state,
        cart: state.cart.map((product) => {
          if (product.id === selectedProduct.id) {
            const total = product.quantity * product.price;
            return { ...product, total };
          }

          return product;
        }),
      };

    case CALCULATE_SUB_TOTAL:
      let total = 0;
      state.cart.map((product) => {
        total = total + product.total;
      });
      return {
        ...state,
        subTotal: total,
      };

    case COUNT_TOTAL:
      let totalCount = 0;
      state.cart.map((product) => {
        totalCount = totalCount + product.quantity;
      });
      return {
        ...state,
        totalCount: totalCount,
      };

    case REMOVE_FROM_CART:
      return {
        ...state,
        cart: state.cart.filter((product) => product.id !== action.payload),
      };

    default:
      return state;
  }
};

export default cartReducer;
